import React from 'react'

export interface TableHeaderProps {
  children: React.ReactNode
  columns: number
  className?: string
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  children,
  columns,
  className = ''
}) => {
  return (
    <div
      className={`bg-gray-50 px-8 py-4 text-sm font-semibold text-gray-700 border-b border-gray-200 ${className}`}
      style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {children}
    </div>
  )
}
